import React from 'react'
import Home from './pages/home'
import Products from './pages/products'
import ProductDetails from './pages/product-details'
import BlogDetails from './pages/blog-detail'
import Branches from './pages/branches'
import AboutUs from './pages/about-us'
import ContactUs from './pages/contact-us'
import Blogs from './pages/blogs'
import Shop from './pages/shop'
import Employment from './pages/employment'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './layout/navbar/navbar'
import MainLayout from './layout/layout';

const RouterComponent = () => {
    return (
        <Router>
            <Navbar />
            <div className="App">
            </div>
            <Routes>
                <Route element={<MainLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/product" element={<ProductDetails />} />
                    <Route path="/blog" element={<BlogDetails />} />
                    <Route path="/branches" element={<Branches />} />
                    <Route path="/about-us" element={<AboutUs />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/blogs" element={<Blogs />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/employment" element={<Employment />} />
                </Route>
            </Routes>


        </Router>

    )
}

export default RouterComponent;